import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ItemList from '../ItemList/ItemList'; // ✅ Mantiene el mismo componente de listado
import "../ItemListContainer/style.css";

const diasSemana = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

const ItemsListContainer = () => {
  const [viandas, setViandas] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    axios.get('https://pedir-viandas.p89nps.easypanel.host/api/viandas')
      .then(response => {
        setViandas(response.data);
        console.log("DATOS OBTENIDOS", response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  // **Agrupar viandas por día**
  const viandasPorDia = diasSemana.reduce((acc, dia) => {
    acc[dia] = viandas.filter(vianda => vianda.dia_semana === dia);
    return acc;
  }, {});

  return (
    <Container className="fondo">
      <h2 className="titulo-combos text-center my-4">📅 Nuestras Viandas por Día</h2>

      {diasSemana.map((dia) => (
        <div key={dia} className="mb-4">
          <h3 
   id={`dia-${dia}`}
  className="text-center banner-dia" 
  style={{
    backgroundColor: "#66bb6a",
    color: "whitesmoke",
    width: "100%",
    padding: "10px 0",
    borderRadius: "5px",
    fontWeight: "bold",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
  }}
>
  {dia}
</h3>

          <Row className="gx-4 gy-4 d-flex justify-content-center">
            {viandasPorDia[dia]?.length > 0 ? (
              viandasPorDia[dia].slice(0, 3).map((vianda) => ( // ✅ Máximo 3 viandas por día
                <Col key={vianda.id} xs={12} sm={6} md={4} lg={4}> {/* ✅ Distribuye en 3 columnas */}
                  <ItemList item={[vianda]} /> {/* ✅ Mantiene el mismo componente de listado */}
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <p className="text-center text-muted">No hay viandas disponibles para este día.</p>
              </Col>
            )}
          </Row>
        </div>
      ))}
    </Container>
  );
};

export default ItemsListContainer;
